export const KIOSK_ENDPOINTS = {
    CONFIG: '/kiosk-api/config',
    INIT_KIOSK_CODE: '/kiosk-api/init'
};
